import pt from "../../locales/pt.json";

// Relacionamento Familiar
export const textoEspec1 = pt.especTextos.textoEspec1;

// Relacionamento Amoroso
export const textoEspec2 = pt.especTextos.textoEspec2;

// Autoestima e autoconfiança
export const textoEspec3 = pt.especTextos.textoEspec3;

// Transtornos e Gerenciamento de Emoções
export const textoEspec4 = pt.especTextos.textoEspec4;

// Ansiedade
export const textoEspec5 = pt.especTextos.textoEspec5;

// Estresse, Depressão e Humor
export const textoEspec6 = pt.especTextos.textoEspec6;

// Tratamento Comprovado
export const textoEspec7 = pt.especTextos.textoEspec7;

// Bem-estar integral
export const textoEspec8 = pt.especTextos.textoEspec8;

// Facilidade e Flexibilidade
export const textoEspec9 = pt.especTextos.textoEspec9;

// Apoio Contínuo
export const textoEspec10 = pt.especTextos.textoEspec10;

// Acolhimento Profissional
export const textoEspec11 = pt.especTextos.textoEspec11;

// Terapia Personalizada
export const textoEspec12 = pt.especTextos.textoEspec12;